import { lazy, Suspense, useState } from 'react';
import Loading from '../Loading';
import moment from 'moment-jalaali';
import fa from '../../../node_modules/apexcharts/dist/locales/fa.json'
moment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true });

const Chart = lazy(() => import('react-apexcharts' /*webpackChunkName: "lazyChart"*/))


const ComparisonChart = ({ data }) => {

    const findTextByNumber = (number) => {
        const result = data?.data.find(item => {
            const keys = Object.keys(item)
            return keys.some(key => item[key] === number)
        })
        return result ? result.text : number
    }

    // مرتب‌سازی داده‌ها بر اساس تاریخ
    const sortedData = data.data.sort((a, b) => new Date(a.name) - new Date(b.name))

    const series = data.lines.map(line => {
        return {
            name: `${line.name.replace(/^\d+_/, '')}`,
            data: sortedData
                .filter(d => d[line.name] !== undefined)
                .map(d => {
                    return {
                        x: new Date(d.name).getTime(),
                        y: d[line.name] || 0,
                        tooltip: findTextByNumber(d[line.name])
                    };
                })
        };
    });


    console.log(series);

    const options = {
        chart: {
            locales: [fa],
            defaultLocale: 'fa',
            fontFamily: 'IRANSansWeb',
            id: 'reportChartData',
            zoom: {
                enabled: false
            }
        },
        xaxis: {
            type: 'datetime',
            labels: {
                formatter: function (value) {
                    return moment(value).locale('fa').format('jD jMMMM jYYYY')
                }
            }
        },
        stroke: {
            curve: 'smooth'
        },
        dataLabels: { enabled: false },
        legend: {
            position: 'top',
            horizontalAlign: 'center'
        },
        colors: ['#2cb7af', '#5098ef'],
        tooltip: {
            shared: true,
            intersect: false,
            x: {
                format: 'dd MMM yyyy',
                formatter: function (value) {
                    return moment(value).locale('fa').format('jD jMMMM jYYYY')
                }
            },
            y: {
                formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                    const tooltipData = w.globals.initialSeries[seriesIndex].data[dataPointIndex].tooltip;
                    return tooltipData;
                }
            }
        },

    }

    return (data &&
        <>
            <Suspense fallback={<Loading styles='mini' />}>
                <Chart
                    options={options}
                    series={series}
                    height={450}
                    type='area'
                    className='zst4td'
                />
            </Suspense>

        </>
    )
}

export default ComparisonChart;